import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputTextAreaSF from '../../../widgets/form/InputTextAreaSF'

const SendLeadDashboardEmailModalUI = ({ context, successMsg, errorList, setErrorList,
  sendEmailMode, submitted, onSubmit, onCancelClick,
  emailTemplateList, selectedTemplateCode, onTemplateSelect,
  subject, message, onMessageChange,
  editMode, onEditClick,
  toEmails, newEmail, onNewEmailChange, onAddEmail, onRemoveEmail, emailError,
}) =>
  <ModalFormUI
    context={context}
    titleLabel='Send New Communication'
    buttonLabel='Send'
    cancelLabel='Cancel'
    isOpen={sendEmailMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    <div className='ld_modal_scroll_body'>
      <div className='g_m_bottom_100'>
        <b>To:</b>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginTop: '8px' }}>
          {
            (toEmails || []).map(e =>
              <span key={e} style={{
                display: 'inline-flex', alignItems: 'center', gap: '8px',
                background: '#eef1f5', borderRadius: '16px', padding: '6px 12px'
              }}>
                {e}
                <span style={{ cursor: 'pointer', fontWeight: 'bold' }}
                  onClick={() => onRemoveEmail(e)}>×</span>
              </span>
            )
          }
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '8px' }}>
          <input type='text' name='newEmail' placeholder='Add email address'
            value={newEmail || ''} onChange={onNewEmailChange}
            onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); onAddEmail() } }}
            style={{ flex: 1, padding: '8px', border: '1px solid #ccc', borderRadius: '4px' }}
          />
          <button type='button' onClick={onAddEmail}>+ Add</button>
        </div>
        {emailError && <div className='g_small' style={{ color: '#c0392b', marginTop: '4px' }}>{emailError}</div>}
      </div>
      <div className='g_flex_h g_flex_top g_m_top_100'>
        <div className='g_flex_v g_flex_left'>
          <b>Please select a Template</b>
          {
            (emailTemplateList || []).map((template, i) =>
              <label key={i} className='g_flex_h g_flex_left g_m_top_50'>
                <input type='radio' name='emailTemplate' value={template.code}
                  checked={selectedTemplateCode === template.code}
                  onChange={onTemplateSelect}
                />
                <span className='g_m_left_50'>{template.label}</span>
              </label>
            )
          }
        </div>

        <div className='g_flex_v g_flex_right' style={{ flex: 1, marginLeft: '20px' }}>
          <div className='g_flex_h g_flex_left'>
            <b>Preview</b>
          </div>
          {
            subject &&
            <div className='g_muted g_m_top_50'>Subject: {subject}</div>
          }
          {
            !editMode && message &&
            <div className='g_m_top_50' dangerouslySetInnerHTML={{ __html: message }} />
          }
          {
            editMode &&
            <InputTextAreaSF type='text' name='message' label=''
              value={message} onChange={onMessageChange}
            />
          }
          {
            selectedTemplateCode && !editMode &&
            <button type='button' className='g_m_top_100' onClick={onEditClick}>Edit</button>
          }
          {
            editMode &&
            <div className='g_muted g_small g_m_top_50'>Changes save automatically as you type.</div>
          }
        </div>
      </div>
    </div>
  </ModalFormUI>

export default SendLeadDashboardEmailModalUI